export default __webpack_public_path__ + "static/media/operacionNoDisponible.f507e248.svg";